import { Component } from '@angular/core';

@Component({
    selector: 'body',
    templateUrl: './app.component.html'
})
export class AppComponent { }



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/app.component.ts